var COLUNAS = 3;
var LINHAS = 9;
var COR = 'rgba(211, 47, 47, 0.14)';
var ANGULO = (-30 * Math.PI) / 180;
var ALTURA_LINHA = 1.3;
export var montarTextoMarcaDagua = function (_a) {
    var nome = _a.nome, matricula = _a.matricula, empresa = _a.empresa, abertoEm = _a.abertoEm;
    var identificacao = [nome, matricula].filter(Boolean).join(' · ');
    var origem = [empresa, abertoEm.toLocaleString('pt-BR')].filter(Boolean).join(' · ');
    return ['DISTRIBUIÇÃO PROIBIDA', identificacao, origem].filter(Boolean).join('\n');
};
/**
 * Desenha a marca d'água nos pixels da página já renderizada: ela não existe no DOM
 * e acompanha qualquer captura de tela da página.
 */
export var desenharMarcaDagua = function (contexto, texto) {
    var _a = contexto.canvas, width = _a.width, height = _a.height;
    var larguraCelula = width / COLUNAS;
    var alturaCelula = height / LINHAS;
    var tamanhoFonte = Math.max(10, Math.round(width / 55));
    var linhas = texto.split('\n');
    contexto.save();
    contexto.fillStyle = COR;
    contexto.font = "bold " + tamanhoFonte + "px sans-serif";
    contexto.textAlign = 'center';
    contexto.textBaseline = 'middle';
    for (var linha = 0; linha < LINHAS; linha++) {
        var _loop_1 = function (coluna) {
            contexto.save();
            contexto.translate(larguraCelula * (coluna + 0.5), alturaCelula * (linha + 0.5));
            contexto.rotate(ANGULO);
            var deslocamentoInicial = ((linhas.length - 1) * tamanhoFonte * ALTURA_LINHA) / 2;
            linhas.forEach(function (textoLinha, indice) {
                contexto.fillText(textoLinha, 0, indice * tamanhoFonte * ALTURA_LINHA - deslocamentoInicial);
            });
            contexto.restore();
        };
        for (var coluna = 0; coluna < COLUNAS; coluna++) {
            _loop_1(coluna);
        }
    }
    contexto.restore();
};
